<template>
  <v-card outlined tile class="d-flex justify-start">
    <v-select
      :items="wsGOSTNamesItems"
      item-text="GRADE_NAME"
      item-value="GRADE_ID"
      :value="value"
      @input="setValue"
      label="Наименование топлива по ГОСТ"
      :hint= "`${value ? value.GRADE_CODE : ''}`"
      persistent-hint
      return-object
      no-data-text="Нет данных"
      class="pl-3 pr-3"
    ></v-select>
  </v-card>
</template>

<script>
import { RCPT_GET_GOST_GRADES_LIST, RCPT_SET_FILTER } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'wsGOSTGradeSelector',
  props: ['GOST_ID', 'value', 'setGlobalFilter'],
  data () {
    return {
      currentGrade: null,
      wsGOSTNamesItems: []
    }
  },
  watch: {
    GOST_ID (val) {
      console.log('wsGOSTGradeSelector: GOST changed', val)
      this.getGOSTGradesList()
    }
  },
  computed: {
  },
  methods: {
    setValue (val) {
      console.log('wsGOSTGradeSelector:: setValue GRADE changed', val)
      if (this.setGlobalFilter) this.$store.dispatch(RCPT_SET_FILTER, { GRADE_ID: val ? val.GRADE_ID : null })
      this.$emit('input', val || null)
    },
    getGOSTGradesList () {
      const self = this
      this.$store.dispatch(RCPT_GET_GOST_GRADES_LIST, { GOST_ID: this.GOST_ID })
        .then((resp) => {
          self.wsGOSTNamesItems.splice(0, self.wsGOSTNamesItems.length, ...resp)
        })
        .catch((err) => {
          self.wsGOSTNamesItems.splice(0, self.wsGOSTNamesItems.length)
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка ГОСТов для типа рецептур: \n ${err}` })
        })
    }
  },

  mounted: function () {
    console.log('wsGOSTGradeSelector mounted with value ', this.value)
    if (this.wsGOSTNamesItems.length === 0) {
      this.getGOSTGradesList()
    }
  },
  created () {
    console.log('wsGOSTGradeSelector created with value ', this.value)
  }
}
</script>
